var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 14.167V16.667H7.5V14.167H3.33301ZM12.833 10.833V16.667H17V10.833H12.833ZM3.33301 3.33301V9.16699H7.5V3.33301H3.33301ZM12.5 3.33301V5.83301H16.667V3.33301H12.5ZM9.16699 16.667C9.16682 17.5873 8.42037 18.333 7.5 18.333H3.33301C2.41279 18.3328 1.66717 17.5872 1.66699 16.667V14.167C1.66699 13.2466 2.41268 12.5002 3.33301 12.5H7.5C8.42047 12.5 9.16699 13.2465 9.16699 14.167V16.667ZM18.667 16.667C18.6668 17.5873 17.9204 18.333 17 18.333H12.833C11.9128 18.3328 11.1672 17.5872 11.167 16.667V10.833C11.1672 9.91279 11.9128 9.16717 12.833 9.16699H17C17.9204 9.16699 18.6668 9.91268 18.667 10.833V16.667ZM9.16699 9.16699C9.16682 10.0873 8.42037 10.833 7.5 10.833H3.33301C2.41279 10.8328 1.66717 10.0872 1.66699 9.16699V3.33301C1.66717 2.41279 2.41279 1.66717 3.33301 1.66699H7.5C8.42037 1.66699 9.16682 2.41268 9.16699 3.33301V9.16699ZM18.333 5.83301C18.333 6.75337 17.5873 7.49982 16.667 7.5H12.5C11.5795 7.5 10.833 6.75348 10.833 5.83301V3.33301C10.8332 2.41268 11.5796 1.66699 12.5 1.66699H16.667C17.5872 1.66717 18.3328 2.41279 18.333 3.33301V5.83301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d02c7995c43675c933ff421b859b33b3.svg";
export { ForwardRef as ReactComponent };